import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">
      {/* Navigation */}
      <nav className="sticky top-0 left-0 right-0 z-50 bg-white shadow-sm">
        <div className="max-w-[1400px] mx-auto px-20 h-28 flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/a2144585b096b0c5bc2cbabd4c2b6ea8/e662b63e618aedfff5c098ee5ba35e0a.png" 
                alt="DataVerge Solutions Logo" 
                className="h-32 w-auto"
              />
            </Link>
          </div>
          
          <div className="flex items-center gap-10">
            <Link to="/#solutions" className="text-[#000080] hover:text-[#FF6B35] transition-colors cursor-pointer text-base whitespace-nowrap">Solutions</Link>
            <Link to="/#insights" className="text-[#000080] hover:text-[#FF6B35] transition-colors cursor-pointer text-base whitespace-nowrap">Insights</Link>
            <Link to="/#about" className="text-[#000080] hover:text-[#FF6B35] transition-colors cursor-pointer text-base whitespace-nowrap">About</Link>
            <Link to="/#contact" className="text-[#000080] hover:text-[#FF6B35] transition-colors cursor-pointer text-base whitespace-nowrap">Contact</Link>
          </div>

          <Link to="/#contact" className="bg-[#FF6B35] text-white px-8 py-3 rounded-lg hover:bg-[#000080] transition-all flex items-center gap-2 whitespace-nowrap shadow-lg hover:shadow-xl cursor-pointer">
            Get Started
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-[1000px] mx-auto px-20 py-20">
        <h1 className="text-6xl font-bold text-[#000080] mb-8">Terms of Use</h1>
        <div className="text-sm text-[#708090] mb-16">Last Updated: January 22, 2026</div>

        <div className="space-y-12 text-[#708090] leading-relaxed">
          <section>
            <h2 className="text-3xl font-bold text-[#000080] mb-6">1. Acceptance of Terms</h2>
            <p className="text-lg">
              Welcome to the website of DataVerge Solutions LLC ("we," "us," or "our"). By accessing or using our website (datavergesolutions.com), you agree to comply with and be bound by these Terms of Use. If you do not agree to these terms, please do not use our website.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-bold text-[#000080] mb-6">2. Nature of Information (No Professional Advice)</h2>
            <p className="text-lg mb-4">
              The content provided on this website—including research benchmarks, operational insights, and "High Risk" compliance examples—is for general informational purposes only.
            </p>
            <ul className="list-disc pl-8 space-y-2 text-lg">
              <li><strong className="text-[#000080]">Not Legal or Financial Advice:</strong> This information does not constitute legal, accounting, or professional consulting advice.</li>
              <li><strong className="text-[#000080]">No Client Relationship:</strong> Accessing this website or contacting us via email does not create a consultant-client relationship. A formal relationship is only established upon the signing of a written Service Agreement.</li>
              <li><strong className="text-[#000080]">Reliance:</strong> You should not act or refrain from acting on the basis of any content included in this site without seeking appropriate professional advice on the particular facts and circumstances at issue.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-3xl font-bold text-[#000080] mb-6">3. Intellectual Property Rights</h2>
            <p className="text-lg mb-4">
              All content on this website, including but not limited to text, graphics, logos, and research methodologies, is the property of DataVerge Solutions LLC and is protected by United States and international copyright laws.
            </p>
            <ul className="list-disc pl-8 space-y-2 text-lg">
              <li><strong className="text-[#000080]">Limited License:</strong> You may view, download, and print pages from the website for your own internal business use, provided you do not modify the content.</li>
              <li><strong className="text-[#000080]">Prohibitions:</strong> You may not reproduce, duplicate, copy, sell, or exploit any portion of this website (including our research data) for commercial purposes without our express written consent.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-3xl font-bold text-[#000080] mb-6">4. User Conduct</h2>
            <p className="text-lg mb-4">By using this website, you agree not to:</p>
            <ul className="list-disc pl-8 space-y-2 text-lg">
              <li>Use the website for any unlawful purpose or to solicit others to perform or participate in any unlawful acts.</li>
              <li>Attempt to scrape, extract, or harvest data from our website using automated systems (bots, spiders, etc.) without our permission.</li>
              <li>Submit false or misleading information through our contact forms.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-3xl font-bold text-[#000080] mb-6">5. Limitation of Liability</h2>
            <p className="text-lg mb-4">
              To the fullest extent permitted by law, DataVerge Solutions LLC shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from:
            </p>
            <ul className="list-disc pl-8 space-y-2 text-lg">
              <li>Your use or inability to use the website.</li>
              <li>Any errors or omissions in the content.</li>
              <li>Any reliance placed by you on the completeness, accuracy, or existence of any information found on our website.</li>
            </ul>
            <p className="text-lg mt-4">
              The website is provided on an "AS IS" and "AS AVAILABLE" basis.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-bold text-[#000080] mb-6">6. Third-Party Links</h2>
            <p className="text-lg">
              Our website may contain links to third-party websites (such as government portals like NCTracks, Sandata, or Apex Accelerators). We are not responsible for the privacy practices or content of these third-party sites.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-bold text-[#000080] mb-6">7. Governing Law</h2>
            <p className="text-lg">
              These Terms shall be governed by and construed in accordance with the laws of the State of North Carolina, without regard to its conflict of law provisions. Any legal action or proceeding related to this website shall be brought exclusively in a federal or state court of competent jurisdiction sitting in Wake County, North Carolina.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-bold text-[#000080] mb-6">8. Changes to Terms</h2>
            <p className="text-lg">
              We reserve the right to modify these Terms of Use at any time. Your continued use of the website following the posting of changes constitutes your acceptance of those changes.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-bold text-[#000080] mb-6">9. Contact Information</h2>
            <p className="text-lg mb-4">
              For any questions regarding these Terms of Use, please contact us at:
            </p>
            <div className="bg-[#F5F6F7] rounded-xl p-8 space-y-3">
              <p className="text-lg"><strong className="text-[#000080]">DataVerge Solutions LLC</strong></p>
              <p className="text-lg">Raleigh, North Carolina</p>
              <p className="text-lg">Email: Info@datavergesolutions.com</p>
              <p className="text-lg">Phone: 919-275-0574</p>
            </div>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-200">
          <Link to="/" className="text-[#FF6B35] hover:text-[#000080] transition-colors flex items-center gap-2 text-lg font-medium cursor-pointer">
            <i className="ri-arrow-left-line"></i>
            Back to Home
          </Link>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#708090] py-16 mt-20">
        <div className="max-w-[1400px] mx-auto px-20">
          <div className="border-t border-white/20 pt-8">
            <div className="flex items-center justify-between">
              <div className="text-sm text-white/80">
                © 2025 DataVerge Solutions LLC. All rights reserved.
              </div>
              <div className="flex items-center gap-8">
                <Link to="/privacy-policy" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">Privacy Policy</Link>
                <Link to="/terms" className="text-sm text-white hover:text-white/80 transition-colors cursor-pointer">Terms</Link>
                <Link to="/accessibility" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">Accessibility</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
